module.exports = __webpack_public_path__ + "static/activities-25e210f075cf975b72c84e1758cb3580.jpg";